import React from "react";
import Loadable from "react-loadable";
import { Switch, Route } from "react-router-dom";
import { NotFound } from "~/views/Errors";
import LoadingSpinner from "~/components/LoadingSpinner";

const ProjectionsView = Loadable({
    loader: () => import("~/views/admin/projections"),
    loading: LoadingSpinner
});

export default ({ match }) => (
    <Switch>
        <Route path={`${match.url}/`} render={(props) => (<ProjectionsView {...props} mode="forecast" />)} />
        <Route component={NotFound} />
    </Switch>
);